export default __webpack_public_path__ + "static/08-the-latam-large-e885221cff0d47683afd764f22cadafa.svg";